module.exports = __webpack_public_path__ + "static/media/1.9a23a4a4.jpg";